import React from "react";
import { Col, Form, Row } from 'react-bootstrap';
import { FeeThin, getFeeValue } from "domain/fee";
import TypedSelect from "common/ui/TypedSelect";
import NumberEditor from "common/ui/NumberEditor";
import "./AddFee.scss";
import { localizeOfferContract as localize, localizeCommon } from "features/localization/localizeService";

interface AddFeeProps {
    fees: FeeThin[];
    selectedFees: Nullish<FeeThin[]>;
    date: Nullish<Date>;
    disabled: boolean;
    onFeesChanged(fees: Nullish<FeeThin[]>): void;
}

const AddFee: React.FC<AddFeeProps> = props => {

    function onAddFeeClicked() {
        const remainingFees = props.fees?.find(f => !props.selectedFees?.some(sf => sf.id === f.id));
        const remainingFeesArray = remainingFees == null ? [] : [remainingFees];
        const updatedFees = props.selectedFees != null ? [...props.selectedFees, ...remainingFeesArray] : remainingFeesArray;
        props.onFeesChanged(updatedFees);
    }

    function onRemoveFeeClicked(fee: FeeThin) {
        const updatedFees = props.selectedFees?.filter(f => f.id !== fee.id)
        props.onFeesChanged(updatedFees);
    }

    function onFeeValueChanged(fee: FeeThin, value: number | null) {
        const updatedFees = props.selectedFees?.map(f => f.id === fee.id
            ? { ...fee, value: value, months: [] }
            : f)
        props.onFeesChanged(updatedFees);
    }

    function onFeeTypeChanged(fee: FeeThin, oldFee: FeeThin) {
        const updatedFees = props.selectedFees?.map(f => f.id === oldFee.id ? { ...fee, value: getFeeValue(fee, props.date) } : f);
        props.onFeesChanged(updatedFees);
    }

    return <div className="add-fee-modal">{props.selectedFees?.map(fee =>
        <Form.Group key={fee.id} as={Row}>
            <Col xs="4">
                <TypedSelect
                    className="fee-select"
                    disabled={props.disabled}
                    includeInvalidOption
                    nullRowText={localizeCommon("Value_Select")}
                    required
                    value={fee}
                    options={props.fees.filter(f => f.id === fee.id || !props.selectedFees?.some(sf => sf.id === f.id))}
                    valueGetter={f => f.id}
                    textGetter={f => f.name}
                    onValueSelected={f => onFeeTypeChanged(f, fee)} />
            </Col>
            <Col xs="4">
                <NumberEditor className='form-control'
                    step={.01}
                    allowDecimals
                    precision={4}
                    disabled={props.disabled}
                    enforcePrecision
                    value={fee.value}
                    placeholder={"0.0000"}
                    onValueChange={value => onFeeValueChanged(fee, value)}
                />
            </Col>
            <Col xs="4">
                {!props.disabled && <button type="button" className='link-button mr-auto' onClick={() => onRemoveFeeClicked(fee)}>
                    <span className="fa fa-trash remove-fee"></span>
                </button>}
            </Col>
        </Form.Group>
    )}
        {props.fees?.length > 0 && props.selectedFees?.length !== props.fees?.length && !props.disabled && <Form.Group as={Row}>
            <Col xs="4" className="pr-0">
                <button type="button" className='link-button mr-auto float-right' onClick={onAddFeeClicked}>
                    {localize("Details_Button_AddFee")}
                </button>
            </Col>
        </Form.Group>}
    </div>;
}

export default AddFee;